"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressComponentType = void 0;
var AddressComponentType;

(function (AddressComponentType) {
  AddressComponentType["UNKNOWN"] = "UNKNOWN";
  AddressComponentType["locality"] = "locality";
  AddressComponentType["country"] = "country";
  AddressComponentType["administrative_area_level_1"] = "administrative_area_level_1";
  AddressComponentType["administrative_area_level_2"] = "administrative_area_level_2";
  AddressComponentType["administrative_area_level_3"] = "administrative_area_level_3";
  AddressComponentType["administrative_area_level_4"] = "administrative_area_level_4";
  AddressComponentType["administrative_area_level_5"] = "administrative_area_level_5";
  AddressComponentType["street_address"] = "street_address";
  AddressComponentType["colloquial_area"] = "colloquial_area";
  AddressComponentType["sublocality"] = "sublocality";
  AddressComponentType["sublocality_level_1"] = "sublocality_level_1";
  AddressComponentType["sublocality_level_2"] = "sublocality_level_2";
  AddressComponentType["sublocality_level_3"] = "sublocality_level_3";
  AddressComponentType["sublocality_level_4"] = "sublocality_level_4";
  AddressComponentType["sublocality_level_5"] = "sublocality_level_5";
  AddressComponentType["route"] = "route";
  AddressComponentType["intersection"] = "intersection";
  AddressComponentType["political"] = "political";
  AddressComponentType["neighborhood"] = "neighborhood";
  AddressComponentType["premise"] = "premise";
  AddressComponentType["subpremise"] = "subpremise";
  AddressComponentType["plus_code"] = "plus_code";
  AddressComponentType["postal_code"] = "postal_code";
  AddressComponentType["natural_feature"] = "natural_feature";
  AddressComponentType["airport"] = "airport";
  AddressComponentType["park"] = "park";
  AddressComponentType["point_of_interest"] = "point_of_interest";
})(AddressComponentType = exports.AddressComponentType || (exports.AddressComponentType = {}));